import React from 'react'
import { Collapse, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'

import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'

export type TSidebarNestedListItemProps = {
  icon: React.ReactNode | null
  text: string
  children?: React.ReactNode
}

/**
 * SidebarNestedListItem Component
 *
 * @example
 * ```ts
 *   <SidebarNestedListItem icon={item.icon} text={item.text}>
 *     {item.list.map((item2) => (
 *       <SidebarListItem icon={item.icon} text={item.text} />
 *      ))}
 *   </SidebarNestedListItem>
 * ```
 * @param __namedParameters TSidebarNestedListItemProps
 * @returns JSX.Element
 * @category ReactComponents
 */
export const SidebarNestedListItem: React.FC<TSidebarNestedListItemProps> = ({
  icon,
  text,
  children,
}): JSX.Element => {
  const [open, setOpen] = React.useState<boolean>(true)

  const handleClick = () => {
    setOpen(!open)
  }

  return (
    <>
      <ListItemButton onClick={handleClick}>
        <ListItemIcon sx={{ '.MuiSvgIcon-root': { width: '0.85em' } }}>{icon}</ListItemIcon>
        <ListItemText
          primary={text}
          sx={{
            '.MuiTypography-root': {
              fontSize: '1rem',
            },
          }}
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </>
  )
}
